module.exports = "/fonts/herculift.eot?6c4ce174aaef92a687c67ad962d961a6";